import './App.css';
import MainLayout from './Layouts/MainLayout';
import { motion} from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import fondo_med from "./assets/imagenes/fondo_medical.jpg";
import imagen1 from "./assets/imagenes/imagen_1.jpg";
import { RiMindMap } from "react-icons/ri";
import { BiWorld, BiSolidReport } from "react-icons/bi";
import { TbChartInfographic, TbReportAnalytics} from "react-icons/tb";
import { FaRegCheckCircle } from "react-icons/fa";
import { BsFillMegaphoneFill } from "react-icons/bs";
import { MdContactSupport, MdCloudUpload } from "react-icons/md";
import { PiListMagnifyingGlassBold } from "react-icons/pi";
import { FaStar } from "react-icons/fa";
import { useState } from 'react';

const colors = {
  primary: '#1A6B77',
  secondary: '#FBAA2C',
  dark: '#1A1A1A',
  light: '#FFFFFF'
};

function App() {
  const [openIndex, setOpenIndex] = useState(null);
  return (
      <MainLayout>
        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="d-flex align-items-center position-relative"
          style={{
            backgroundImage: `url(${fondo_med})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: '100vh',
            color: '#fff'
          }}
        >

          <div
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1 }}
          ></div>

          <div className="container position-relative" style={{ zIndex: 2 }}>
            <div className="row">
              <div className="col-md-6">
                <h1 className="fw-bold display-4 mb-3">Monitoreo Ocupacional</h1>
                <p className="lead">
                  Plataforma especializada en el monitoreo y gestión de la salud laboral,
                  optimizando el bienestar de los empleados y fortaleciendo la productividad empresarial.
                </p>
                <a href="#servicios" className="btn btn-outline-light mt-4">
                  Contáctanos
                </a>
              </div>
            </div>
          </div>
        </motion.section>
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="py-5 bg-light"
          
          aria-label="Servicios de salud laboral"
        >
          <div className="container">           
            <div className="row row-cols-1 row-cols-md-3 g-4">
              {[
                {
                  icon: <RiMindMap size={60} style={{ color: colors.primary }} />,
                  title: 'Monitoreo de Salud',
                  description: 'Implementamos sistemas que permiten a las empresas gestionar la salud de sus empleados optimizando asi el bienestar general',
                  bgColor: 'white',
                  borderColor: `${colors.primary}20`
                },
                {
                  icon: <TbChartInfographic size={60} style={{ color: colors.primary }} />,
                  title: 'Gestión de Bienestar',
                  description: 'Ofrecemos programas de bienestar que abordan las necesidades especificas de tus empleados para fomentar un ambiente laboral saludable y productivo',
                  bgColor: 'white',
                  borderColor: `${colors.primary}20`
                },
                {
                  icon: <BiWorld size={60} style={{ color: colors.primary }} />,
                  title: 'Educación en Salud',
                  description: 'Proporcionamos recursos educativos para mantener a los empleados informados sobre temas de promoción de la salud y prevención de enfermedades',
                  bgColor: 'white',
                  borderColor: `${colors.primary}20`
                },
              ].map((item, index) => (
                <motion.div
                  key={index}
                  whileHover={{ y: -10, transition: { duration: 0.3 } }}
                  className="col"
                >
                  <div
                    className="card h-100 border-0 rounded-4 p-4 text-center shadow-sm"
                    style={{
                      backgroundColor: item.bgColor,
                      borderTop: `4px solid ${item.borderColor}`,
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <div className="mb-4 d-flex justify-content-center">
                      <div
                        className="p-3 rounded-circle"
                        style={{
                          backgroundColor: `${colors.primary}10`,
                          display: 'inline-flex'
                        }}
                      >
                        {item.icon}
                      </div>
                    </div>
                    <h4
                      className="fw-semibold mb-3"
                      style={{ color: colors.dark }}
                    >
                      {item.title}
                    </h4>
                    <p
                      className="text-muted mb-4"
                      style={{
                        lineHeight: '1.6',
                        fontSize: '0.95rem'
                      }}
                    >
                      {item.description}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.section>
        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="py-5 bg-light"
        >
          <div className="container">
            <div className="row align-items-center g-5">

              <div className="col-lg-6">
                <div className="mb-4">
                  <span
                    className="d-inline-block px-3 py-1 rounded-pill bg-opacity-10"
                    style={{
                      backgroundColor: colors.secondary,
                      color: '#FFFFFF',
                      fontSize: '0.9rem',
                      fontWeight: 600
                    }}
                  >
                    Sobre Nosotros
                  </span>
                </div>
                <h2
                  className="fw-bold mb-4"
                  style={{
                    color: '#1A1A1A',
                    fontSize: '2.3rem',
                    lineHeight: '1.2'
                  }}
                >
                  Innovación en Salud Ocupacional
                </h2>
                <p className="text-muted mb-4 lead">
                  En Medical Assistant, combinamos tecnología y experiencia clínica para transformar la gestión de la salud laboral. Nuestro objetivo es ayudar a las empresas a crear entornos de trabajo seguros, saludables y productivos.
                </p>

                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="d-flex">
                      <div
                        className="me-3 d-flex align-items-center justify-content-center"
                        style={{
                          width: '50px',
                          height: '50px',
                          borderRadius: '12px',
                          backgroundColor: `${colors.primary}15`,
                        }}
                      >
                        <FaRegCheckCircle size={24} style={{ color: colors.primary }} />
                      </div>
                      <div>
                        <h5 className="fw-semibold mb-2" style={{ color: colors.dark }}>
                          Monitoreo
                        </h5>
                        <p className="text-muted mb-0" style={{ fontSize: '0.95rem' }}>
                          Plataforma con registro en calendario y seguimiento continuo de indicadores clave de salud.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex">
                      <div
                        className="me-3 d-flex align-items-center justify-content-center"
                        style={{
                          width: '50px',
                          height: '50px',
                          borderRadius: '12px',
                          backgroundColor: `${colors.primary}15`,
                        }}
                      >
                        <TbChartInfographic size={24} style={{ color: colors.primary }} />
                      </div>
                      <div>
                        <h5 className="fw-semibold mb-2" style={{ color: colors.dark }}>
                          Informes Personalizados
                        </h5>
                        <p className="text-muted mb-0" style={{ fontSize: '0.95rem' }}>
                          Reportes detallados y dashboards interactivos para una gestión basada en datos.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex">
                      <div
                        className="me-3 d-flex align-items-center justify-content-center"
                        style={{
                          width: '50px',
                          height: '50px',
                          borderRadius: '12px',
                          backgroundColor: `${colors.primary}15`,
                        }}
                      >
                        <MdContactSupport size={24} style={{ color: colors.primary }} />
                      </div>
                      <div>
                        <h5 className="fw-semibold mb-2" style={{ color: colors.dark }}>
                          Soporte Especializado
                        </h5>
                        <p className="text-muted mb-0" style={{ fontSize: '0.95rem' }}>
                          Equipo multidisciplinario disponible para asesorarte en cada etapa.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex">
                      <div
                        className="me-3 d-flex align-items-center justify-content-center"
                        style={{
                          width: '50px',
                          height: '50px',
                          borderRadius: '12px',
                          backgroundColor: `${colors.primary}15`,
                        }}
                      >
                        <BsFillMegaphoneFill size={24} style={{ color: colors.primary }} />
                      </div>
                      <div>
                        <h5 className="fw-semibold mb-2" style={{ color: colors.dark }}>
                          Programas de Bienestar
                        </h5>
                        <p className="text-muted mb-0" style={{ fontSize: '0.95rem' }}>
                          Capacitaciones para fomentar hábitos saludables en tu organización.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="position-relative">
                  <img
                    src={imagen1}
                    alt="Equipo de Medical Assistant en acción"
                    className="img-fluid rounded-4 shadow-lg"
                    style={{
                      width: '100%',
                      maxHeight: '500px',
                      objectFit: 'cover',
                    }}
                  />
                  
                </div>
              </div>
            </div>
          </div>
        </motion.section>

        <motion.section
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="py-5 bg-light"
          aria-label="Sección de Servicios"
        >
          <div className="container">

            <div className="row justify-content-center mb-5 text-center">
              <div className="col-md-8 col-lg-6">
                <div className="mb-4">
                  <span
                    className="d-inline-block px-3 py-1 rounded-pill bg-opacity-10"
                    style={{
                      backgroundColor: colors.secondary,
                      color: '#FFFFFF',
                      fontSize: '0.9rem',
                      fontWeight: 600
                    }}
                  >
                    Productos
                  </span>
                </div>
                <h2
                  className="fw-bold mb-3"
                  style={{
                    color: '#1A1A1A',
                    fontSize: '2.2rem',
                    position: 'relative',
                    display: 'inline-block'
                  }}
                >
                  Nuestros Servicios
                </h2>
                <p className="lead text-muted">
                  Solucion integral para el monitoreo y promoción de la salud laboral, diseñadas para potenciar el bienestar de tus colaboradores.
                </p>
                <div
                  style={{
                    height: '4px',
                    width: '80px',
                    backgroundColor: colors.secondary,
                    margin: '15px auto',
                    borderRadius: '2px'
                  }}
                />
              </div>
            </div>

            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
              {[
                {
                  icon: <BsFillMegaphoneFill size={50} style={{ color: colors.primary }} />,
                  title: 'Evaluaciones de Salud',
                  description: 'Evaluaciones médicas periódicas y exámenes especializados para detectar riesgos laborales y prevenir enfermedades ocupacionales.',
                  bgColor: 'rgba(26, 107, 119, 0.05)',
                  borderColor: 'rgba(26, 107, 119, 0.1)'
                },
                {
                  icon: <TbReportAnalytics size={50} style={{ color: colors.primary }} />,
                  title: 'Reportes Inteligentes',
                  description: 'Dashboard interactivo con métricas clave, tendencias y alertas tempranas para una gestión basada en datos.',
                  bgColor: 'rgba(26, 107, 119, 0.05)',
                  borderColor: 'rgba(26, 107, 119, 0.1)'
                },
                {
                  icon: <MdContactSupport size={50} style={{ color: colors.primary }} />,
                  title: 'Soporte 24/7',
                  description: 'Equipo multidisciplinario disponible para resolver dudas, emergencias y acompañar la implementación de programas de salud.',
                  bgColor: 'rgba(26, 107, 119, 0.05)',
                  borderColor: 'rgba(26, 107, 119, 0.1)'
                },
                {
                  icon: <PiListMagnifyingGlassBold size={50} style={{ color: colors.primary }} />,
                  title: 'Asesorías Estratégicas',
                  description: 'Planes personalizados de bienestar laboral, alineados a los objetivos y cultura organizacional de tu empresa.',
                  bgColor: 'rgba(26, 107, 119, 0.05)',
                  borderColor: 'rgba(26, 107, 119, 0.1)'
                },
                {
                  icon: <MdCloudUpload size={50} style={{ color: colors.primary }} />,
                  title: 'Plataforma Tecnológica',
                  description: 'Sistema en la nube para monitoreo en tiempo real, integración con wearables y gestión centralizada de la salud ocupacional.',
                  bgColor: 'rgba(26, 107, 119, 0.05)',
                  borderColor: 'rgba(26, 107, 119, 0.1)'
                },
                {
                  icon: <BiSolidReport size={50} style={{ color: colors.primary }} />,
                  title: 'Programas de Intervención',
                  description: 'Acciones correctivas y preventivas basadas en evidencia, desde talleres hasta campañas de concientización.',
                  bgColor: 'rgba(26, 107, 119, 0.05)',
                  borderColor: 'rgba(26, 107, 119, 0.1)'
                },
              ].map((service, index) => (
                <motion.div
                  key={index}
                  whileHover={{ y: -5, transition: { duration: 0.3 } }}
                  className="col"
                >
                  <div
                    className="card h-100 border-0 rounded-4 p-4 text-center shadow-sm"
                    style={{
                      backgroundColor: service.bgColor,
                      borderTop: `3px solid ${service.borderColor}`,
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <div className="mb-4" style={{ color: colors.primary }}>
                      {service.icon}
                    </div>
                    <h4
                      className="fw-semibold mb-3"
                      style={{ color: colors.dark }}
                    >
                      {service.title}
                    </h4>
                    <p className="text-muted mb-0" style={{ lineHeight: '1.6' }}>
                      {service.description}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.section>
        <motion.section
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="py-5 bg-light"
          aria-label="Planes de la Plataforma"
        >
          <div className="container">
            <div className="text-center mb-5">
              <div className="mb-4">
                <span
                  className="d-inline-block px-3 py-1 rounded-pill bg-opacity-10"
                  style={{
                    backgroundColor: colors.secondary,
                    color: '#FFFFFF',
                    fontSize: '0.9rem',
                    fontWeight: 600
                  }}
                  >
                    Planes adatables
                </span>
              </div>
              <h2
                  className="fw-bold mb-4"
                  style={{
                    color: '#1A1A1A',
                    fontSize: '2.3rem',
                    lineHeight: '1.2'
                  }}
                >
                  Escoge el plan que mejor se alinea con tu operación
                </h2>
              <p className="text-muted mt-3">
                Todos los planes incluyen seguridad de datos, trazabilidad SGSI y soporte técnico especializado.
              </p>
            </div>

            <div className="row row-cols-1 row-cols-md-3 g-4">
              {[
                {
                  name: 'Básico',
                  price: '$99/mes',
                  icon: <FaStar size={25} />,
                  bg: '#ffffff',
                  border: `1px solid ${colors.primary}`,
                  features: [
                    'Reportes de salud',
                    'Soporte multicanal (correo, chat, teléfono)',
                    'Hasta 20 usuarios',
                  ],
                },
                {
                  name: 'Profesional',
                  price: '$199/mes',
                  icon: <FaStar size={25} />,
                  bg: '#f0f8f9',
                  border: `2px solid ${colors.secondary}`,
                  highlight: true,
                  features: [
                    'Reportes de salud',
                    'Soporte multicanal (correo, chat, teléfono)',
                    'Hasta 100 usuarios',
                    'Acceso a Capacitaciónes',
                  ],
                },
                {
                  name: 'Corporativo',
                  price: '$299/mes',
                  icon: <FaStar size={25} />,
                  bg: '#ffffff',
                  border: `1px solid ${colors.primary}`,
                  features: [
                    'Reportes de salud',
                    'Soporte multicanal (correo, chat, teléfono)',
                    'Hasta 500 usuarios',
                    'Acceso a Capacitaciónes',
                  ],
                },
              ].map((plan, index) => (
                <div key={index} className="col">
                  <div
                    className={`card h-100 rounded-4 p-4 shadow ${plan.highlight ? 'border border-3' : ''}`}
                    style={{
                      backgroundColor: plan.bg,
                      borderColor: plan.border,
                      transition: 'transform 0.3s ease',
                    }}
                  >
                    <h4 className="fw-semibold text-center mb-1">{plan.name}</h4>
                    <h5 className="text-center mb-3" style={{ color: colors.secondary }}>
                      {plan.price}
                    </h5>
                    <div className="text-center mb-3" style={{ color: colors.primary }}>
                      {plan.icon}
                      {plan.icon}
                      {plan.icon}
                      {plan.icon}
                      {plan.icon}
                    </div>
                    <ul className="list-unstyled mb-4">
                      {plan.features.map((feature, i) => (
                        <li key={i} className="mb-2 d-flex align-items-center">
                          <FaRegCheckCircle className="me-2" style={{ color: colors.primary }} />
                          {feature}
                        </li>
                      ))}
                    </ul>
                    <div className="text-center mt-auto">
                      <a
                        href="contacto"
                        className="btn btn-outline-primary rounded-pill px-4"
                      >
                        Solicitar información
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </motion.section>
        <motion.section
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="py-5 bg-white"
          aria-label="Testimonios de Clientes"
        >
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-md-7">
                <div className="row row-cols-1 row-cols-md-2 g-4">
                  {[
                    {
                      name: 'Carla Fernández',
                      role: 'Gerente de Recursos Humanos',
                      company: '',
                      quote: 'La plataforma nos permitió centralizar el monitoreo de salud ocupacional con una trazabilidad impecable. El soporte es excepcional.',
                    },
                    {
                      name: 'Luis Ramírez',
                      role: 'Jefe de Seguridad y Salud',
                      company: '',
                      quote: 'Gracias a Medical Assistant, logramos reducir incidentes laborales. Los reportes son claros y accionables.',
                    },
                    {
                      name: 'María Torres',
                      role: 'Directora de Bienestar Corporativo',
                      company: '',
                      quote: 'La interfaz es intuitiva y el equipo siempre está disponible. Es una herramienta clave para nuestra estrategia de bienestar.',
                    },
                  ].map((testimonial, index) => (
                    <div key={index} className="col">
                      <div className="card h-100 border-0 shadow-sm rounded-4 p-4">
                        <p className="text-muted mb-4" style={{ fontStyle: 'italic' }}>
                          {testimonial.quote}
                        </p>
                        <div className="mt-auto">
                          <h6 className="fw-bold mb-0" style={{ color: colors.primary }}>
                            {testimonial.name}
                          </h6>
                          <small className="text-muted">
                            {testimonial.role} – {testimonial.company}
                          </small>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-md-5">
                <div className="text-start">
                  <span
                    className="d-inline-block px-3 py-1 rounded-pill mb-3"
                    style={{
                      backgroundColor: colors.secondary,
                      color: colors.light,
                      fontSize: '0.85rem',
                      fontWeight: 600,
                      letterSpacing: '0.5px'
                    }}
                  >
                    Opiniones reales
                  </span>
                  <h2 className="fw-bold display-5" style={{ color: '#1A1A1A' }}>
                    Lo que nuestros clientes dicen
                  </h2>
                  <p className="text-muted mt-3">
                    Empresas que confían en nuestra plataforma comparten su experiencia y resultados.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.section>
      </MainLayout>

  );
}

export default App;
